import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { zIndex as zIndexConst } from '@ecp/common/src/style/constant';
import FloatingUnstyled from '@ecp/common/src/components/unstyled/floating/FloatingUnstyled';
import { floatingClassNames, placements } from '@ecp/common/src/components/unstyled/floating/useCustomFloating';
import {
  defaultArrowPosition,
  defaultArrowSize,
  StyledArrowCss,
  StyledClose,
} from '@ecp/common/src/components/tooltip/Tooltip';

const Tooltip = ({ children, ...props }) => (
  <FloatingUnstyled
    blockAutoFocus
    openWhenClicked
    closeWhenOutside
    rootComponent={StyledTooltip}
    arrowComponent={StyledArrow}
    arrowInnerComponent={StyledArrowInner}
    closeComponent={<StyledClose />}
    offset={3 - defaultArrowPosition}
    arrowPadding={20}
    useShift
    shiftPadding={10}
    {...props}
  >
    {children}
  </FloatingUnstyled>
);

Tooltip.displayName = 'Tooltip';

Tooltip.propTypes = {
  children: PropTypes.node,
  placement: PropTypes.oneOf(placements),
};

Tooltip.defaultProps = {
  closeWhenOutside: true,
};

const StyledTooltip = styled.div`
  width: max-content;
  border: 1px solid ${boTheme.color.menu1};
  padding: 16px 20px;
  background-color: ${boTheme.color.sub10};
  z-index: ${({ zIndex = zIndexConst.tooltip }) => zIndex};

  &:focus-visible {
    outline: none;
  }
`;

const StyledArrow = styled.div`
  background: transparent;
  border-right: 1px solid ${boTheme.color.menu1};
  width: ${() => `${defaultArrowSize}px`};
  height: ${() => `${defaultArrowSize}px`};
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${boTheme.color.menu1};

  ${StyledArrowCss}
  &.${floatingClassNames.right} {
    left: ${() => `${defaultArrowPosition - 1}px`};
  }
  &.${floatingClassNames.left} {
    right: ${() => `${defaultArrowPosition - 1}px`};
  }
  &.${floatingClassNames.top} {
    bottom: ${() => `${defaultArrowPosition - 1}px`};
  }
  &.${floatingClassNames.bottom} {
    top: ${() => `${defaultArrowPosition - 1}px`};
  }
`;

const StyledArrowInner = styled.div`
  width: 0;
  height: 0;
  border-right-width: ${() => `${defaultArrowSize}px`};
  border-right-style: solid;
  border-right-color: ${boTheme.color.sub10};
  border-bottom-width: ${() => `${defaultArrowSize}px`};
  border-bottom-style: solid;
  border-bottom-color: transparent;

  ${StyledArrowCss}
  &.${floatingClassNames.right} {
    left: ${() => `${defaultArrowPosition}px`};
  }
  &.${floatingClassNames.left} {
    right: ${() => `${defaultArrowPosition}px`};
  }
  &.${floatingClassNames.top} {
    bottom: ${() => `${defaultArrowPosition}px`};
    left: ${() => `${defaultArrowPosition - 10}px`};
  }
  &.${floatingClassNames.bottom} {
    top: ${() => `${defaultArrowPosition}px`};
  }
`;

export default Tooltip;
